var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VDataTable',{staticClass:"vacancy-table",attrs:{"headers":_vm.headers,"items":_vm.vacancies,"item-key":"title","hide-default-footer":"","disable-pagination":"","hide-default-header":_vm.vacancies.length === 0},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('VacancyPresetCopyTableRow',{key:item.id,attrs:{"company":_vm.company,"vacancy":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }